export default __webpack_public_path__ + "static/Aspirelabs-5979881381b028757e46d439fccbea70.jpg";